// iOS Safari never fires "contextmenu" on a long press, so menus (leave server, message and member actions)
// could not be opened on iPhone/iPad. A 500 ms touch without moving now opens the same menu as a right click.
const ios = /iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
if ((ios || /Android/i.test(navigator.userAgent)) && typeof window !== 'undefined') {
  let timer = 0, startX = 0, startY = 0, target: EventTarget | null = null, fired = false;
  const cancel = () => { clearTimeout(timer); timer = 0; };
  // Android WebViews differ in whether they generate a contextmenu event.
  // Keep the native event when it arrives first and avoid opening twice.
  window.addEventListener('contextmenu',e=>{if(!e.isTrusted)return;if(fired){e.preventDefault();e.stopPropagation();}else cancel();},true);
  window.addEventListener('touchstart', e => {
    if (e.touches.length !== 1) return cancel();
    const t = e.touches[0]; startX = t.clientX; startY = t.clientY; target = e.target; fired = false;
    const el = target as HTMLElement | null;
    if (el?.closest('input,textarea,[contenteditable=true],video,input[type=range]')) return;
    cancel();
    timer = window.setTimeout(() => {
      timer = 0; fired = true;
      try { (navigator as any).vibrate?.(10); } catch {}
      target?.dispatchEvent(new MouseEvent('contextmenu', { bubbles: true, cancelable: true, clientX: startX, clientY: startY, view: window }));
    }, 500);
  }, { passive: true });
  window.addEventListener('touchmove', e => { const t = e.touches[0]; if (t && Math.hypot(t.clientX - startX, t.clientY - startY) > 10) cancel(); }, { passive: true });
  window.addEventListener('touchend', e => { cancel(); if (fired) { e.preventDefault(); fired = false; } }, { passive: false });
  window.addEventListener('touchcancel', cancel, { passive: true });
  // Swallow the click that iOS sends after the long press, so the item under the finger is not opened as well.
  window.addEventListener('click', e => { if (fired) { e.preventDefault(); e.stopPropagation(); fired = false; } }, true);
  const style = document.createElement('style');
  style.textContent = '[class*="rail"] img,[class*="member"] img,.avatar img{-webkit-touch-callout:none}';
  document.head.appendChild(style);
}
export {};
